import Carousel from './carousel.vue';
import Slide from './slide.vue';

const install = (Vue) => {
  Vue.component(Carousel.name, Carousel);
  Vue.component(Slide.name, Slide);
};

export default {
  install,
};

export { Carousel, Slide };
